import { gql } from '@apollo/client';

export const GET_ADMIN_LIST = gql`
    query ($input: GetAdminListDTO!) {
        getAdminList(input: $input) {
            message
            adminList {
                _id
                name
                email
                phone
                status
                role
            }
            pagination {
                total
                hasNextPage
            }
        }
    }
`;

export const GET_ADMIN = gql`
    query ($id: String!) {
        getAdmin(id: $id) {
            message
            admin {
                _id
                name
                email
                phone
                role
                status
                tags
                canLoginToBusinesses
                signature
            }
        }
    }
`;

export const LIST_ADMIN_NOTES = gql`
    query ($input: ListAdminNotesInput!) {
        listAdminNotes(input: $input) {
            data {
                _id
                body
                authorId
                authorName
                isPinned
                createdAt
                updatedAt
            }
            pagination {
                total
                hasNextPage
            }
        }
    }
`;

export const GET_ADMIN_SIGN_IN_LOG = gql`
    query ($input: ListAdminSignInLogInput!) {
        getAdminSignInLog(input: $input) {
            data {
                _id
                ip
                browser
                userAgent
                createdAt
            }
            pagination {
                total
                hasNextPage
            }
        }
    }
`;

export const GET_ADMIN_PERMISSION_CHANGE_LOG = gql`
    query ($input: ListAdminPermissionChangeLogInput!) {
        getAdminPermissionChangeLog(input: $input) {
            data {
                _id
                field
                oldValue
                newValue
                changedByAdminId
                changedByName
                createdAt
            }
            pagination {
                total
                hasNextPage
            }
        }
    }
`;

export const GET_BUSINESS_LOGIN_LOG_FOR_ADMIN = gql`
    query ($input: ListBusinessLoginLogForAdminInput!) {
        getBusinessLoginLogForAdmin(input: $input) {
            data {
                _id
                businessId
                businessName
                ip
                userAgent
                createdAt
            }
            pagination {
                total
                hasNextPage
            }
        }
    }
`;

export const GET_TEAM_MEMBER_GOOGLE_CONNECTION = gql`
    query ($adminId: String!) {
        getTeamMemberGoogleConnection(adminId: $adminId) {
            connected
            googleEmail
            connectedAt
        }
    }
`;

export const GET_USER_PROFILE = gql`
    query {
        getUserProfile {
            _id
            name
            email
            phone
            status
            role
            profileImage
            profileImageUrl
            canLoginToBusinesses
            signature
        }
    }
`;
